/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type AzureExpFeatureValue = string | number | boolean;
export type AzureExpFeatureFlag = { namespace: string; name: string; value: AzureExpFeatureValue };

export class AzureExpStore {
    public readonly impressionId: string;

    public readonly assignmentContext: string;

    public readonly featureFlags: AzureExpFeatureFlag[];

    constructor(impressionId: string, assignmentContext: string, featureFlags: AzureExpFeatureFlag[]) {
        this.impressionId = impressionId;
        this.featureFlags = featureFlags;
        this.assignmentContext = assignmentContext;
    }

    public getFeatureFlagsByNamespace = (namespace: string) => this.featureFlags.filter(ff => ff.namespace === namespace);

    public getFeatureFlagByName = (flagName: string) =>
        this.featureFlags.find(ff => ff.name === flagName) || { namespace: '', name: '', value: false };
}
